import { useMemo } from 'react';
import useAnalyticsStore from '../../../../../store/analyticsStore';
import { IEnrichedMetadata } from '../../../../../types/metadata';

export const useEnrichedTask = (
  datasetId: string,
  coordinates: number[]
): IEnrichedMetadata | undefined => {
  const enrichedMetadata = useAnalyticsStore((state) => state.enrichedMetadata);

  return useMemo(
    () =>
      enrichedMetadata.find(
        (task) =>
          task.DatasetId === datasetId &&
          task.CoordinatesString === coordinates.join()
      ),
    [enrichedMetadata, datasetId, coordinates]
  );
};
